
import { ICloseServiceOrder } from '@interfaces/close-service-order.interface';
import { IServiceOrder } from '@interfaces/service-order.interface';
import { createAction, props } from '@ngrx/store';
import { StatusEnums } from '@root/core/enums/status-orden-service.enums';


enum ServiceOrderActionType {
  Load = '[ServiceOrder Component] Load',
  SearchAllServiceOrders = '[ServiceOrder Component] Search all Service Order',
  SearchAllServiceOrdersSuccess = '[ServiceOrder Component] Search all Service Order Success',

  UpdateServiceOrder = '[ServiceOrder Component] Update Service Order',
  UpdateServiceOrderSuccess = '[ServiceOrder Component] Update ServiceOrder Success',

  CreateServiceOrder = '[ServiceOrder Component] Create Service Order',
  CreateServiceOrderSuccess = '[ServiceOrder Component] Create Service Order Success',

  SearchServiceOrdersByTechnical = '[ServiceOrder Component] Search Service Order By Technical',
  SearchServiceOrdersByTechnicalSuccess = '[ServiceOrder Component] Search Service Order By Technical Success',

  SearchServiceOrdersByOwner = '[ServiceOrder Component] Search Service Order By Owner',
  SearchServiceOrdersByOwnerSuccess = '[ServiceOrder Component] Search Service Order By Owner Success',

  SearchAllServiceOrdersByVehicleId = '[ServiceOrder Component] Search Service Order By Vehicle Id',
  SearchAllServiceOrdersByVehicleIdSuccess = '[ServiceOrder Component] Search Service Order By Vehicle Id Success',

  Selected = '[ServiceOrder Page] Select',

  changeStatus = '[ServiceOrder Component] change status Service Order',
  changeStatusSuccess = '[ServiceOrder Component] change status Service Order Success',

  closeServiceOrder = '[ServiceOrder Component] close Service Order',
  closeServiceOrderSuccess = '[ServiceOrder Component] close Service Order Success',

  ActionFailure = '[ServiceOrder API] Execute action failure',
  ActionSuccess = '[ServiceOrder API] Execute action success',
  LoadSuccess = '[ServiceOrder API] Load Success',
  Refresh = '[ServiceOrder Page] Refresh',
  SubmitSuccess = '[ServiceOrder API] Submit Success',

  resetFlags = '[ServiceOrder API] Reset Flags',
}

const load = createAction(ServiceOrderActionType.Load);
const SearchAllServiceOrders = createAction(
  ServiceOrderActionType.SearchAllServiceOrders
);
const searchAllServiceOrdersSuccess = createAction(
  ServiceOrderActionType.SearchAllServiceOrdersSuccess,
  props<{ serviceOrderList: IServiceOrder[] }>()
);

const SearchServiceOrdersByOwner = createAction(
  ServiceOrderActionType.SearchServiceOrdersByOwner,
  props<{ ownerId: number }>()
);
const SearchServiceOrdersByOwnerSuccess = createAction(
  ServiceOrderActionType.SearchServiceOrdersByOwnerSuccess,
  props<{ serviceOrderList: IServiceOrder[] }>()
);


const createServiceOrder = createAction(
  ServiceOrderActionType.CreateServiceOrder,
  props<{ serviceOrder: IServiceOrder }>()
);

const CreateServiceOrderSuccess = createAction(
  ServiceOrderActionType.CreateServiceOrderSuccess,
  props<{ serviceOrder: IServiceOrder }>()
);

const actionFailure = createAction(
  ServiceOrderActionType.ActionFailure,
  props<{ error: string }>()
);

const actionSuccess = createAction(
  ServiceOrderActionType.ActionSuccess,
  props<{ msg: string }>()
);

const loadSuccess = createAction(
  ServiceOrderActionType.LoadSuccess,
  props<{ serviceOrders: IServiceOrder[] }>()
);

const submitSuccess = createAction(
  ServiceOrderActionType.SubmitSuccess,
  props<{ msg: string }>()
);

const refresh = createAction(ServiceOrderActionType.Refresh);

const select = createAction(
  ServiceOrderActionType.Selected,
  props<{ serviceOrder: IServiceOrder }>()
);

const updateServiceOrder = createAction(
  ServiceOrderActionType.UpdateServiceOrder,
  props<{ serviceOrder: IServiceOrder, ref: any }>()
);
const SearchServiceOrdersByTechnical = createAction(
  ServiceOrderActionType.SearchServiceOrdersByTechnical,
  props<{ technicalId: number }>()
);
const SearchServiceOrdersByTechnicalSuccsess = createAction(
  ServiceOrderActionType.SearchServiceOrdersByTechnicalSuccess,
  props<{ serviceOrderList: IServiceOrder[] }>()
);

const SearchAllServiceOrdersByVehicleId = createAction(
  ServiceOrderActionType.SearchAllServiceOrdersByVehicleId,
  props<{ vehicleId: number }>()
);

const SearchAllServiceOrdersByVehicleIdSuccess = createAction(
  ServiceOrderActionType.SearchAllServiceOrdersByVehicleIdSuccess,
  props<{ serviceOrderList: IServiceOrder[] }>()
);

const resetFlags = createAction(
  ServiceOrderActionType.resetFlags
);

const ChangeStatus = createAction(
  ServiceOrderActionType.changeStatus,
  props<{ status: StatusEnums, serviceOrderId: number }>()
);

const ChangeStatusSuccess = createAction(
  ServiceOrderActionType.changeStatusSuccess,
  props<{ serviceOrder: IServiceOrder }>()
);

const CloseServiceOrder = createAction(
  ServiceOrderActionType.closeServiceOrder,
  props<{ data: ICloseServiceOrder, serviceOrderId: number }>()
);

const CloseServiceOrderSuccess = createAction(
  ServiceOrderActionType.changeStatusSuccess,
  props<{ serviceOrder: IServiceOrder }>()
);
//closeServiceOrder
export const ServiceOrdersActions = {
  SearchServiceOrdersByTechnical,
  SearchServiceOrdersByTechnicalSuccsess,
  createServiceOrder,
  CreateServiceOrderSuccess,
  SearchAllServiceOrders,
  searchAllServiceOrdersSuccess,
  SearchServiceOrdersByOwner,
  SearchServiceOrdersByOwnerSuccess,
  select,
  SearchAllServiceOrdersByVehicleId,
  SearchAllServiceOrdersByVehicleIdSuccess,
  resetFlags,
  ChangeStatus,
  ChangeStatusSuccess,

  CloseServiceOrder,
  CloseServiceOrderSuccess,
  
  actionFailure,
  actionSuccess,
  loadSuccess,
  submitSuccess,
  refresh,
  updateServiceOrder,


}

